import React, { useCallback, useState } from 'react';
import Cropper from 'react-easy-crop';
import PropTypes from 'prop-types';
import { getCroppedImg } from './getCroppedImg';
import './cropperModal.scss';
import { Reset, Tick } from '@/assets/images';

const CropperModal = ({ src, onCrop, circularCrop = true, viewOnly = false }) => {
   const [crop, setCrop] = useState({ x: 0, y: 0 });
   const [zoom, setZoom] = useState(1);
   const [croppedAreaPixels, setCroppedAreaPixels] = useState(null);

   const onCropComplete = useCallback((_, croppedPixels) => {
      setCroppedAreaPixels(croppedPixels);
   }, []);

   const handleConfirm = async () => {
      const blob = await getCroppedImg(src, croppedAreaPixels);
      onCrop(blob);
   };

   const handleReset = () => {
      setCrop({ x: 0, y: 0 });
      setZoom(1);
   };

   return (
      <div className="cropper-container ct-flex ct-fcol">
         <div className="cropper-body">
            <Cropper
               disableAutomaticStylesInjection={viewOnly}
               image={src}
               crop={crop}
               zoom={zoom}
               aspect={1}
               cropShape={circularCrop ? 'round' : 'rect'}
               onCropChange={!viewOnly ? setCrop : () => {}}
               onZoomChange={!viewOnly ? setZoom : () => {}}
               onCropComplete={!viewOnly ? onCropComplete : () => {}}
               showGrid={false}
            />
         </div>
         {!viewOnly && (
            <div className="cropper-footer ct-flex ct-fcol">
               <input
                  type="range"
                  min={1}
                  max={3}
                  step={0.1}
                  value={zoom}
                  onChange={e => setZoom(Number(e.target.value))}
               />

               <div className="cropper-actions ct-flex ct-aiCenter ct-jcCenter ct-gap20">
                  <button onClick={handleReset} title="Reset" className="ct-flexCenter">
                     <Reset />
                  </button>
                  <button onClick={handleConfirm} title="Confirm" className="ct-flexCenter">
                     <Tick />
                  </button>
               </div>
            </div>
         )}
      </div>
   );
};

CropperModal.propTypes = {
   src: PropTypes.string.isRequired,
   onCrop: PropTypes.func.isRequired,
   circularCrop: PropTypes.bool,
   viewOnly: PropTypes.bool,
};

export default CropperModal;
